import { configureStore } from '@reduxjs/toolkit'
import userSlice from './user'
import cardsReducer from './cards'
import popupsSlice from './popups'
import craftingSlice from './crafting'
import soundsSlice from './sounds'

export const store = configureStore({
  reducer: {
    user: userSlice,
    cards: cardsReducer,
    popups: popupsSlice,
    crafting: craftingSlice,
    sounds: soundsSlice,
  },
}, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
